'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseMenu = require('../BaseMenu');

var _BaseMenu2 = _interopRequireDefault(_BaseMenu);

var _BaseMenuSection = require('../BaseMenuSection');

var _BaseMenuSection2 = _interopRequireDefault(_BaseMenuSection);

var _BaseMenuItem = require('../BaseMenuItem');

var _BaseMenuItem2 = _interopRequireDefault(_BaseMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homeLink = {
  display: 'Home',
  href: '/'
};

var UserMenu = function (_Component) {
  (0, _inherits3.default)(UserMenu, _Component);

  function UserMenu(props) {
    (0, _classCallCheck3.default)(this, UserMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserMenu.__proto__ || (0, _getPrototypeOf2.default)(UserMenu)).call(this, props));

    _this.handleSignOut = _this.handleSignOut.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserMenu, [{
    key: 'handleSignOut',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (window && window.analytics) {
                  // https://segment.com/docs/sources/website/analytics.js/#reset-logout
                  window.analytics.reset();
                }
                window.location.href = '/logout';

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSignOut() {
        return _ref.apply(this, arguments);
      }

      return handleSignOut;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          links = _props.links,
          entitlements = _props.entitlements,
          showHome = _props.showHome,
          showDetails = _props.showDetails,
          onClickLink = _props.onClickLink,
          freeTrialEligible = _props.freeTrialEligible;

      return _react2.default.createElement(
        _BaseMenu2.default,
        { position: 'right' },
        showHome ? _react2.default.createElement(_BaseMenuSection2.default, { links: [homeLink], onClick: onClickLink }) : null,
        user && showDetails ? _react2.default.createElement(
          _BaseMenuSection2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'quiver-user-menu__user-name' },
            _react2.default.createElement(
              'span',
              null,
              user.firstName
            ),
            ' ',
            _react2.default.createElement(
              'span',
              null,
              user.lastName
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-user-menu__user-email' },
            user.email
          ),
          entitlements.includes('sl_premium') ? _react2.default.createElement(
            'div',
            { className: 'quiver-user-menu__premium-status' },
            'Premium'
          ) : null
        ) : null,
        freeTrialEligible ? _react2.default.createElement(
          _BaseMenuSection2.default,
          null,
          _react2.default.createElement(
            _BaseMenuItem2.default,
            { href: '/upgrade', onClick: onClickLink },
            _react2.default.createElement(
              'div',
              { className: 'quiver-user-menu__cta' },
              'Try Premium Free for 15 days'
            )
          )
        ) : null,
        user ? _react2.default.createElement(_BaseMenuSection2.default, { links: links, onClick: onClickLink }) : null,
        user ? _react2.default.createElement(
          _BaseMenuSection2.default,
          null,
          _react2.default.createElement(
            _BaseMenuItem2.default,
            { onClick: this.handleSignOut },
            'Sign Out'
          )
        ) : null
      );
    }
  }]);
  return UserMenu;
}(_react.Component);

UserMenu.propTypes = {
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    display: _propTypes2.default.string,
    href: _propTypes2.default.string,
    newWindow: _propTypes2.default.bool
  })),
  user: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    firstName: _propTypes2.default.string,
    lastName: _propTypes2.default.string
  }),
  entitlements: _propTypes2.default.arrayOf(_propTypes2.default.string),
  serviceConfig: _propTypes2.default.shape({
    serviceUrl: _propTypes2.default.string
  }),
  showHome: _propTypes2.default.bool,
  showDetails: _propTypes2.default.bool,
  onClickLink: _propTypes2.default.func,
  freeTrialEligible: _propTypes2.default.bool
};
UserMenu.defaultProps = {
  links: [],
  user: null,
  entitlements: [],
  onClickLink: null,
  freeTrialEligible: false
};
exports.default = UserMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/UserMenu/UserMenu.js
// module id = 352
// module chunks = 0